import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Paper } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import { colors, theme, StyledParagraphBlock } from '../../../theme/Global'

export const CustomPaper = styled(Paper)`
  background: ${colors.white};
  margin: 5vh auto 0 auto;
  max-width: 587px;
  padding: 59px 89px;
  text-align: center;
  width: 90%;
`

export const ErrorMessageWrapper = styled(Dialog)`
  width: 100%;
  maxWidth: none;
`

export const CustomErrorMessage = styled.div`
  background: ${colors.white};
  border-left: 1rem solid ${colors.govDocsRed};
  box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);
  margin: 0 auto;
  padding: 1rem;
  min-width: 350px;
}`

export const CustomFullPageWrapper = styled.div`
  background-color: ${theme.colors.blueBackground};
  bottom: 0;
  height: 100%;
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  flex: 1;
`

export const CustomParagraphBlock = styled(StyledParagraphBlock)`
  text-align: left;
  margin: 0em 0px;
`

export const StyledCircularProgress = styled(CircularProgress)`
  margin-right: 10px;
`
